<template>
  <members-layout :title="$t('lblTitle')">
    <template v-slot:content>
      <v-container fluid>
        <h3 v-html="$t('lblDescription')"/>
      </v-container>
    </template>
  </members-layout>
</template>

<script>
/**
 * @copyright       Palace Resorts
 * @description     Pantallapara la captura de incidentes
 * @author          Roberto Pérez Guzmán
 * @creationDate    27 de Mayo del 2020
 */

// Members layout
import MembersLayout from "@/layouts/Members.layout";
// Internacionalización. Para la presentación de mensajes en diferentes idiomas
import i18nMessages from "./i18n/messages";

export default {
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    // Incluimos el layout que utilizará este módulo
    MembersLayout,
  },
  data () {
    return {
      moduleName: "FORBIDDEN"
    }
  },
  
};
</script>
